import(/* webpackMode: "eager" */ "/app/src/app/company/careers/page.tsx");
